import { Component, h, Prop } from "@stencil/core";
import { scrollToTop } from "../../utils/scroll-to-top";
import { ButtonSize } from "../../utils/button.enum";

@Component({
    tag: "ux-scroll-to-top-button",
    styleUrl: "scroll-to-top-button.scss",
    shadow: true
})
export class ScrollToTopButton {
    /**
     * Represents the label which is applied solely as an `aria-label` for accessibility purposes.
     * This label is not visually displayed but is essential for screen readers and other assistive technologies.
     */
    @Prop() readonly label: string;

    componentWillLoad() {
        if (!this.label) {
            // eslint-disable-next-line no-console
            console.warn("Accessibility error: 'label' property is required for screen reader identification.");
        }
    }

    render() {
        return (
            <ux-button label={this.label} onClick={() => scrollToTop()} size={ButtonSize.Icon}>
                <ux-icon slot="icon" aria-hidden="true" name="arrow-up" weight="normal" />
            </ux-button>
        );
    }
}
